/*
 * Lectura de la sabana mensual (.xlsx) en el navegador, replica del handleFile
 * del HTML original: elige la hoja con las columnas esperadas y devuelve las
 * filas crudas para que prepareRows las normalice. El archivo nunca sale del equipo.
 */
import * as XLSX from "xlsx";

//Columnas minimas que debe traer una hoja para considerarla la sabana
const REQUIRED_HEADERS = ["NOMBRE", "GERENCIA", "DO", "VALOR"];

/**
 * Lee los encabezados de una hoja en mayusculas y sin espacios sobrantes
 * @param {Object} mWorkbook Libro de trabajo de XLSX
 * @param {string} sName Nombre de la hoja
 * @returns {Array} Encabezados de la primera fila
 */
const readHeaders = (mWorkbook, sName) => {
  const mFirst = XLSX.utils.sheet_to_json(mWorkbook.Sheets[sName], { header: 1, defval: null })[0] || [];
  return mFirst.map((vHeader) => (vHeader || "").toString().trim().toUpperCase());
};

/**
 * Busca la hoja con las columnas de la sabana ("FINAL" tiene prioridad)
 * @param {Object} mWorkbook Libro de trabajo de XLSX
 * @returns {string|null} Nombre de la hoja o null si ninguna sirve
 */
export const pickDataSheet = (mWorkbook) => {
  const hasAll = (sName) => {
    const mHeaders = readHeaders(mWorkbook, sName);
    return REQUIRED_HEADERS.every((sReq) => mHeaders.includes(sReq));
  };
  if (mWorkbook.SheetNames.includes("FINAL") && hasAll("FINAL")) return "FINAL";
  return mWorkbook.SheetNames.find(hasAll) || null;
};

/**
 * Convierte el contenido de un .xlsx en filas crudas de la sabana
 * @param {ArrayBuffer} mBuffer Contenido binario del archivo
 * @returns {Object} { rows, sheetName }
 */
const parseWorkbook = (mBuffer) => {
  const mWorkbook = XLSX.read(mBuffer, { type: "array", cellDates: true });
  const sSheet = pickDataSheet(mWorkbook);
  if (!sSheet) {
    throw new Error(
      `Ninguna hoja trae las columnas esperadas (${REQUIRED_HEADERS.join(", ")}). Hojas encontradas: ${mWorkbook.SheetNames.join(", ")}`,
    );
  }
  return { rows: XLSX.utils.sheet_to_json(mWorkbook.Sheets[sSheet], { defval: null }), sheetName: sSheet };
};

/**
 * Lee la sabana seleccionada por el usuario
 * @param {File} mFile Archivo .xlsx elegido
 * @returns {Promise<Object>} { rows, sheetName }
 */
export const readSabana = (mFile) =>
  new Promise((resolve, reject) => {
    const mReader = new FileReader();
    mReader.onerror = () => reject(new Error("No se pudo leer el archivo."));
    mReader.onload = (mEvent) => {
      try {
        resolve(parseWorkbook(mEvent.target.result));
      } catch (mError) {
        reject(mError);
      }
    };
    mReader.readAsArrayBuffer(mFile);
  });
